import React, { useState } from "react";
import { useJsqel } from "../../api/jsqel";
import { useStore } from "../../store/store";
import { Input, Card, Form, Button, Alert } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";

const centeredContainer = {
	maxWidth: "500px",
	minHeight: "100vh",
	display: "flex",
	margin: "auto",
};
const UserLoginForm = ({ history }) => {
	const { dispatch } = useStore();
	const [errorMessage, setErrorMessage] = useState(null);

	const next = (location) =>
		location &&
			location.search &&
			location.search.length &&
			location.search.startsWith("?next=")
			? location.search.slice(6)
			: "";
	const afterLogin = ({ results, error }) => {
		if (results && results.token && results.role) {
			dispatch({ type: "LOGIN", ...results });
			setErrorMessage(null);
			history.push("/" + next(history.location));
		} else {
			setErrorMessage("Identifiant ou mot de passe incorrect");
			clear();
		}
	};
	const [{ loading }, refresh, clear] = useJsqel("buzzee/login", {
		sendItNow: false,
		XMLC_UserName: "",
		Password: "",
		callback: afterLogin,
	});

	return (
		<div style={centeredContainer}>
			<Card
				style={{ margin: "auto" }}
				loading={loading}
				title={
					<div style={{ textAlign: "center" }}>
						<div style={{ fontSize: "1.4em", fontWeight: 600 }}>
							Synchronisation des calendriers
						</div>
						<div
							style={{
								fontSize: "0.85em",
								fontWeight: 400,
								color: "#666",
								marginTop: "4px",
							}}
						>
							Connectez-vous avec vos identifiants Buzzee
						</div>
					</div>
				}
			>
				<Form onFinish={(values) => { setErrorMessage(null); refresh(values); }}>
					{errorMessage && (
						<Alert
							message={errorMessage}
							type="error"
							showIcon
							style={{ marginBottom: 16 }}
						/>
					)}
					<Form.Item
						name="XMLC_UserName"
						rules={[
							{ required: true, message: "Veuillez saisir votre identifiant" },
							{ min: 4, message: "4 caractères minimum" },
						]}
					>
						<Input
							prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
							placeholder="Identifiant"
						/>
					</Form.Item>
					<Form.Item
						name="Password"
						rules={[
							{ required: true, message: "Veuillez saisir votre mot de passe" },
							{ min: 4, message: "4 caractères minimum" },
						]}
					>
						<Input
							prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
							type="password"
							placeholder="Mot de passe"
						/>
					</Form.Item>
					<Button type="primary" loading={loading} htmlType="submit">
						Se connecter
					</Button>
				</Form>
			</Card>
		</div>
	);
};
export default UserLoginForm;
